import { useStore } from "zustand";
import { useDashboardName } from "../../store/headerName";
import { useEffect, useState } from "react";
import { Modal, Table } from "antd";
import BaseCard from "../../components/card/BaseCard";
import { Icon } from "@iconify/react";
import BaseTable from "../../components/BaseTable";
import type { TableProps } from "antd/lib";
import { useParams } from "react-router";
import { $api, type components } from "../../helper";
import ButtonLinkIcon from "../../components/ButtonLinkIcon";
import { useNotify } from "../../helper/notify";
import FilterSearch from "../../components/filter/FilterSearch";
import Status from "../../components/Status";
import ButtonLinkIconSvg from "../../components/ButtonLinkIconSvg";
import PenSquare from "../../components/svg/PenSquare";

export default function CommentList() {
  const [isOpen, setIsOpen] = useState(false);
  const notify = useNotify();
  const params = useParams();
  const [id, setId] = useState("");
  const { data, isLoading } = $api.useQuery(
    "get",
    "/site-api/v1/course-comment/",
    {
      params: {
        query: {
          course_u_id: params.id ?? "",
        },
      },
    },
  );
  const { mutate, isPending } = $api.useMutation(
    "delete",
    "/site-api/v1/course/",
  );
  const { setDashboardName } = useStore(useDashboardName);
  useEffect(() => {
    setDashboardName("لیست دوره ها");
  }, []);

  const columns: TableProps<
    components["schemas"]["SiteCourseCommentItem"]
  >["columns"] = [
    {
      title: "#",
      dataIndex: "key",
      key: "key",
      render: (_, record, index) => <span>{index + 1}</span>,
    },
    {
      title: "متن نظر",
      dataIndex: "text",
      key: "text",
      render: (_, record) => (
        <div className="w-150 line-clamp-1">{record.text}</div>
      ),
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <FilterSearch
          clearFilters={clearFilters}
          confirm={confirm}
          selectedKeys={selectedKeys}
          setSelectedKeys={setSelectedKeys}
        />
      ),
      onFilter: (value, record) =>
        record?.text
          ?.toLowerCase()
          ?.includes(value.toString().toLocaleLowerCase()),
      filterIcon: () => (
        <Icon className="text-xl" icon={"solar:magnifer-linear"} />
      ),
    },
    {
      title: "وضعیت نمایش",
      key: "show",
      dataIndex: "show",
      render: (_, record) => (
        <Status
          title={
            record.status === 1
              ? "درحال انتظار"
              : record.status === 2
                ? "تایید شده"
                : "رد شده"
          }
          style={
            record.status === 1
              ? "warning"
              : record.status === 2
                ? "success"
                : "error"
          }
        />
      ),
    },
    {
      title: "عملیات",
      key: "action",
      render: (_, record) => (
        <div className="flex items-center gap-1">
          {/* <ButtonLinkIcon
            to={{
              pathname: "/courses/add-course",
              search: "?u_id=" + record.u_id,
            }}
            icon="solar:pen-new-square-linear"
            className="text-primary-500!"
          /> */}
          <ButtonLinkIconSvg
            icon={<PenSquare />}
            to={{
              pathname: "/courses/add-course",
              search: "?u_id=" + record.u_id,
            }}
            className="text-primary-500!"
          />
        </div>
      ),
    },
  ];

  return (
    <div className="grid grid-cols-12 gap-6">
      <Modal open={isOpen} onCancel={() => setIsOpen(false)}></Modal>
      <div className="w-full flex-1 col-span-full">
        <BaseCard props={{ className: "flex-1 flex-col flex gap-6" }}>
          <BaseTable
            props={{
              className: "min-w-0!",
            }}
          >
            <Table<components["schemas"]["SiteCourseCommentItem"]>
              scroll={{
                x: "max-content",
              }}
              columns={columns}
              dataSource={data?.data}
              loading={isLoading}
            />
          </BaseTable>
        </BaseCard>
      </div>
    </div>
  );
}
